import { dataSender } from '../../common/utils/router';
import T, { t } from '../../common/components/T';
import LoadMore from './components/LoadMore/LoadMore';
import { API_SERVER_URL } from '../../common/utils/utils';
import uikit from '../../project/uikit/styles';

export const thead = {
    data: [
        {
            name: 'username',
            type: 'login',
            title: <T textName='structure-thead-1-new-2' defaultStr='ФИО, ID пользователя' page='/structure' />
        },
        {
            name: 'activity',
            type: 'activityDate',
            title: <T textName='structure-thead-2-activity' defaultStr='Статус' page='/structure' />,
            align: 'left',
            nowrap: { td: true }
        },
        {
            name: 'rank',
            type: 'rang',
            title: <T textName='structure-thead-2-new' defaultStr='Квалификация' page='/structure' />,
            align: 'left',
            nowrap: { td: true }
        },
        {
            name: 'package',
            type: 'package',
            title: <T textName='structure-thead-3-1' defaultStr='Стартовый набор' page='/structure' />,
            align: 'left'
        },
        {
            name: 'branch',
            type: 'branch',
            title: <T textName='structure-thead-4-1' defaultStr='Ветка' page='/structure' />,
            align: 'left'
        },
        {
            name: 'country',
            type: 'text',
            title: <T textName='structure-thead-5-1' defaultStr='Страна, Город' page='/structure' />,
            align: 'left'
        },
        {
            name: 'register_date',
            type: 'text',
            title: <T textName='structure-thead-6-1' defaultStr='Дата регистрации' page='/structure' />,
            align: 'left'
        },
        {
            name: 'sponsor',
            type: 'login',
            title: <T textName='structure-thead-7-1' defaultStr='Спонсор' page='/structure' />,
            align: 'left'
        },
        {
            name: 'contacts',
            type: 'contacts',
            title: <T textName='structure-thead-8-1' defaultStr='Контакты' page='/structure' />
        }
        // {
        //     name: 'partner_stats',
        //     type: 'partner_stats',
        //     title: <T textName='structure-thead-6' defaultStr='Партнеры' page='/structure' />
        // }
    ]
};

export const getCurrentUserData = (profileData, dataStats) => {
    return {
        data: [
            {
                username: {
                    username: profileData.username,
                    first_name: profileData?.first_name,
                    full_name: profileData?.full_name,
                    last_name: profileData?.last_name,
                    patronymic: profileData?.patronymic,
                    id: profileData.id
                },
                activity: profileData?.marketing_profile,
                rank: profileData?.marketing_profile?.rank ? profileData?.marketing_profile?.rank : null,
                package: profileData?.marketing_profile?.package ? { ...profileData?.marketing_profile?.package } : null,
                branch: profileData?.marketing_profile?.position,
                country: [profileData?.country, profileData?.city]
                    .filter((it) => it)
                    .map((it) => it?.name)
                    .join(', '),
                register_date: profileData?.created_at_formatted,
                sponsor: profileData?.sponsor,
                contacts: profileData?.contacts,
                marketing_profile: profileData?.marketing_profile,
                has_children: dataStats?.data?.base_stats?.children_count,
                sponsorId: [profileData?.id] || 0,
                activeRow: profileData?.is_new_partner ? 'is_new_partner' : false,
                links: profileData?.links,
                id: profileData?.id,
                depth: profileData?.depth
            }
        ]
    };
};

export const transformData = (dataUser) => {
    const newData = [];
    const group = [
        'username',
        'activity',
        'rank',
        'package',
        'branch',
        'country',
        'register_date',
        'sponsor',
        'contacts',
        'has_children',
        'id',
        'sponsorId',
        'level',
        'links',
        'isLast'
    ];

    if (dataUser) {
        let accum = {};
        Object.keys(dataUser?.data).map((idx) => {
            group.map((item, key) => {
                {
                    Object.keys(dataUser.data[idx]).map((alias) => {
                        if (group[key] === 'username') {
                            accum['username'] = dataUser.data[idx]?.username?.username
                                ? dataUser.data[idx]?.username
                                : {
                                      id: dataUser.data[idx]['id'],
                                      username: dataUser.data[idx]['username'],
                                      full_name: dataUser.data[idx]['full_name'],
                                      is_deleted: dataUser.data[idx]['deleted']
                                  };
                        }
                        if (group[key] === 'activity') {
                            accum.activity = dataUser.data[idx]?.marketing_profile;
                        }
                        if (group[key] === 'level' || group[key] === 'depth') {
                            accum[group[key]] = dataUser.data[idx].depth || 1;
                        }
                        if (group[key] === 'partner_stats') {
                            accum.partner_stats = {
                                descendants_count: dataUser.data[idx].descendants_count
                            };
                        }
                        if (group[key] === 'branch') {
                            accum.branch = +dataUser?.data[idx]?.marketing_profile?.position;
                        }
                        if (group[key] === 'register_date') {
                            accum.register_date = dataUser?.data[idx]?.created_at_formatted || '-';
                        }
                        if (group[key] === 'country') {
                            accum.country = [dataUser?.data[idx]?.country, dataUser?.data[idx]?.city]
                                .filter((it) => it)
                                .map((it) => it?.name)
                                .join(', ');
                        }
                        if (group[key] === 'sponsor') {
                            accum.sponsor = dataUser?.data[idx]?.sponsor || null;
                        }
                        if (group[key] === 'has_children') {
                            accum.has_children = Boolean(dataUser.data[idx].children_count);
                        }
                        if (group[key] === 'rank') {
                            accum.rank = dataUser.data[idx]?.marketing_profile?.rank ? (
                                dataUser.data[idx]?.marketing_profile?.rank
                            ) : (
                                <T textName='no-rank' defaultStr='Без ранга' page='/structure' />
                            );
                        }
                        if (group[key] === 'package') {
                            accum.package = dataUser.data[idx]?.marketing_profile?.package;
                        }
                        if (group[key] === 'links') {
                            accum.links = {
                                ...dataUser.data[idx].links,
                                id: dataUser.data[idx].id
                            };
                        } else if (group[key] === alias) {
                            accum[`${alias}`] = dataUser.data[idx][`${alias}`];
                        }
                    });
                }
            });
            if (dataUser.data[idx]?.deleted) {
                accum.activeRow = 'deleted';
                accum.deleted = true;
            } else if (dataUser.data[idx]?.blocked) {
                accum.activeRow = 'blocked';
            } else if (dataUser.data[idx]?.is_new_partner) {
                accum.activeRow = 'is_new_partner';
                accum.is_new_partner = true;
            }
            Object.keys(dataUser.data[idx]).map((k) => {
                if (accum[k] === undefined) {
                    accum[k] = dataUser.data[idx][k];
                }
            });
            newData.push(accum);
            accum = {};
        });
        return {
            ...dataUser,
            data: newData
        };
    }
    return false;
};

export const changeGridData = (
    user,
    userData,
    setStructureViewData,
    breadCrumbsUsers,
    setBreadCrumbsUsers,
    userToken,
    setAlertData,
    lang,
    display_country
) => {
    const currentData = userData?.data[0];
    const parent = breadCrumbsUsers[breadCrumbsUsers?.findIndex((el) => el.id === user.id) - 1];

    if (user.id === currentData.id || !parent) {
        setStructureViewData(userData);
        const indexOfUser = breadCrumbsUsers.reduce((res, item, idx) => {
            if (item.username === user.username) res = idx;
            return res;
        }, 0);
        const newBreadCrumbsUsers = breadCrumbsUsers.slice(0, indexOfUser);
        setBreadCrumbsUsers(newBreadCrumbsUsers.length ? newBreadCrumbsUsers : false);
        return;
    }
    dataSender(
        `${API_SERVER_URL}/api/v1/user/partners/${user.id}/descendants?filter[parent_id]=${user.id}&page[size]=20&include=marketingProfile,sponsor,profile.country,profile.city`,
        'GET',
        false,
        (response) => {
            setAlertData(false);
            setStructureViewData(transformData(response.data));
            const indexOfUser = breadCrumbsUsers.reduce((res, item, idx) => {
                if (item.username === user.username) res = idx;
                return res;
            }, 0);
            const newBreadCrumbsUsers = breadCrumbsUsers.slice(0, indexOfUser + 1);
            setBreadCrumbsUsers(newBreadCrumbsUsers.length ? newBreadCrumbsUsers : false);
        },
        (data) => {
            if (data.message) {
                setAlertData({ type: 'error', cont: data.message });
            } else {
                setAlertData({ type: 'error', cont: data?.false });
            }
        },
        userToken,
        lang,
        false,
        false,
        false,
        !!Number(display_country) ? { 'Display-Country': '1' } : null
    );
};

export const afterOpenFunction = (data, variant, setBreadCrumbsUsers, type) => {
    if (variant === 2) {
        setBreadCrumbsUsers((pre) => (type ? [] : pre ? [...pre, data] : [data]));
    }
};

export const getUserReferals = (
    rowData,
    setAlertData,
    setGridData,
    afterOpenSwitherClick,
    userToken,
    setActiveTr,
    viewData,
    variant,
    canPress,
    lang,
    next,
    anchor,
    display_country
) => {
    const { id: userId, level, isOpen, sponsorId } = rowData;
    let url =
        next ||
        `${API_SERVER_URL}/api/v1/user/partners/${userId}/descendants?filter[parent_id]=${userId}&page[size]=20&include=marketingProfile,sponsor,profile.country,profile.city`;
    if (canPress?.current !== false) {
        if ((!isOpen && rowData.links.children) || next) {
            if (canPress) canPress.current = false;

            dataSender(
                url,
                'GET',
                false,
                (res) => {
                    setAlertData(false);
                    const addedData = transformData({
                        ...res.data,
                        data: res.data.data.map((item, idx) => ({
                            ...item,
                            level: level + 1,
                            sponsorId: sponsorId ? [...sponsorId, userId] : [userId],
                            isLast: res.data.data.length - 1 === idx
                        }))
                    }).data;

                    let newAddedData = addedData;
                    if (res.data.meta.last_page > res.data.meta.current_page && variant === 1) {
                        newAddedData = addedData.map((addedItem, idx) => {
                            if (addedData.length === idx + 1) {
                                return {
                                    ...addedItem,
                                    addedComponent: (
                                        <LoadMore
                                            canPress={canPress}
                                            func={() =>
                                                getUserReferals(
                                                    rowData,
                                                    setAlertData,
                                                    setGridData,
                                                    () => {},
                                                    userToken,
                                                    setActiveTr,
                                                    viewData,
                                                    variant,
                                                    canPress,
                                                    lang,
                                                    res.data.links?.next,
                                                    addedItem.id,
                                                    display_country
                                                )
                                            }
                                        />
                                    )
                                };
                            } else {
                                return addedItem;
                            }
                        });
                    }
                    setGridData((pre) => ({
                        ...(variant === 2 ? res.data : pre),
                        data:
                            variant === 2
                                ? addedData
                                : pre?.data.reduce((accum, item) => {
                                      if (anchor) {
                                          if (item.id === anchor) {
                                              accum = [
                                                  ...accum,
                                                  {
                                                      ...item,
                                                      isOpen: true,
                                                      addedComponent: false
                                                  },
                                                  ...newAddedData
                                              ];
                                          } else {
                                              accum.push(item);
                                          }
                                      } else {
                                          if (item.id === userId) {
                                              accum = [
                                                  ...accum,
                                                  {
                                                      ...item,
                                                      isOpen: true,
                                                      addedComponent: false
                                                  },
                                                  ...newAddedData
                                              ];
                                          } else {
                                              accum.push(item);
                                          }
                                      }
                                      return accum;
                                  }, [])
                    }));
                    if (variant === 1) {
                        afterOpenSwitherClick('open');
                    } else {
                        afterOpenSwitherClick();
                    }

                    if (canPress) canPress.current = true;
                },
                (data) => {
                    if (data.message) {
                        setAlertData({ type: 'error', cont: data.message });
                    }

                    if (canPress) canPress.current = true;
                },
                userToken,
                lang,
                false,
                false,
                false,
                !!Number(display_country) ? { 'Display-Country': '1' } : null
            );
        } else {
            const newViewData = {
                ...viewData,
                data: viewData.data.reduce((accum, item) => {
                    if (item.id === userId) {
                        accum.push({
                            ...item,
                            isOpen: false
                        });

                        return accum;
                    }

                    if (item.sponsorId && item.sponsorId.includes(userId)) return accum;

                    accum.push(item);
                    return accum;
                }, [])
            };

            setGridData(newViewData);
            if (variant === 1) {
                afterOpenSwitherClick('close');
            } else {
                afterOpenSwitherClick();
            }
        }
        setActiveTr(false);
    }
};
export const getCounterTree = (gridData, mobile, translation) => {
    const subValueDefault = {
        subValueIcon: 'user-cross',
        subValueStyles: {
            background: 'var(--redTransparentColor)',
            fill: 'var(--redColor)',
            borderRadius: '8px',
            padding: '3.5px 9px',
            fontStyle: 'normal',
            fontWeight: 500,
            ...uikit.text,
            color: 'var(--redColor)',
            display: 'flex',
            alignItems: 'center',
            marginLeft: '10px'
        }
    };
    return [
        {
            title: !mobile
                ? t('StructureHeadInfo-new', 'Новых партнеров', '/structure', translation)
                : t('StructureHeadInfo-new-xs', 'Новых', '/structure', translation),
            value: Number(gridData?.new_descendants_count || '0').toLocaleString(),
            icon: 'plus-with-elipse',
            background: 'var(--greenLightExtraTransparentColor)',
            color: 'var(--greenColor)',
            subValue: gridData?.new_descendants_deleted_count || '0',
            ...subValueDefault
        },
        {
            title: mobile
                ? t('StructureHeadInfo-active-xs', 'Активных', '/structure', translation)
                : t('treegraph-CounterTree-Active', 'Активные партнеры', '/structure', translation),
            value: Number(gridData?.active_descendants_count || '0').toLocaleString(),
            icon: 'star-with-elipse',
            background: 'rgba(var(--blueDeep) / 0.12)',
            color: 'var(--blueColor)',
            subValue: gridData?.active_descendants_deleted_count || '0',
            ...subValueDefault
        },
        {
            title: mobile
                ? t('treegraph-CounterTree-SelfInviteMob', 'Лично пригл.', '/structure', translation)
                : t('StructureHeadInfo-invited', 'Лично приглашенных', '/structure', translation),
            value: Number(gridData?.referral_descendants_count || gridData?.base_stats?.children_count || '0').toLocaleString(),
            icon: 'handshake-with-elipse',
            background: 'var(--orangeTransparentColor)',
            color: 'var(--orangeDeepColorLight)',
            subValue: gridData?.referral_descendants_count || gridData?.base_stats?.children_deleted_count || '0',
            ...subValueDefault
        },
        {
            title: mobile
                ? t('StructureHeadInfo-total-xs', 'Всего', '/structure', translation)
                : t('StructureHeadInfo-total', 'Всего партнеров', '/structure', translation),
            value: Number(gridData?.descendants_count || gridData?.base_stats?.descendants_count || '0').toLocaleString(),
            icon: 'users-fill-colored',
            background: 'rgba(var(--purple) / 0.12)',
            color: 'var(--purpleDeepColor)',
            subValue: gridData?.descendants_count || gridData?.base_stats?.descendants_deleted_count || '0',
            ...subValueDefault
        }
    ];
};

export const getFilterFields = () => {
    return [
        {
            title: '',
            fields: [
                {
                    type: 'input',
                    title: {
                        body: <T textName='structure-filter-field-1-title' defaultStr='ID пользователя' page='/structure' />
                    },
                    attribute: 'id'
                },
                {
                    type: 'input',
                    title: {
                        body: <T textName='structure-filter-field-2-title' defaultStr='Ф.И.О пользователя' page='/structure' />
                    },
                    attribute: 'name'
                },
                {
                    type: 'phone-widget',
                    title: {
                        body: <T textName='structure-filter-field-3-title' defaultStr='Номер телефона' page='/structure' />
                    },
                    attribute: 'profile.phone'
                }
            ]
        }
    ];
};
